module.exports = __webpack_public_path__ + "img/cedula-residencial.3c7c3f67.png";